import React, { memo } from "react";
import { withNamespaces } from "react-i18next";
import { LEGITIMATION_STATUS_CONFIG } from "./constants";

const LegitimationStatusBadge = ({ t, status }) => {
  const config = LEGITIMATION_STATUS_CONFIG[status];

  if (!config) {
    return null;
  }

  return (
    <div
      style={{
        minWidth: "82px",
        fontSize: "10px",
        fontWeight: 700,
        padding: "3px 8px",
        background: config.backgroundColor,
        color: "#1D1D1D",
        borderRadius: "7px",
        whiteSpace: "nowrap",
        textAlign: "center",
        display: "inline-block",
      }}
      className="dt-task-status"
    >
      {t(config.labelKey)}
    </div>
  );
};

export default withNamespaces()(memo(LegitimationStatusBadge));
